import { render, staticRenderFns } from "./ModalPlus.vue?vue&type=template&id=34197633&"
import script from "./ModalPlus.vue?vue&type=script&lang=js&"
export * from "./ModalPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports